import React from "react";
import { capitalizeFirstLetter, isArray } from "../../../utils/commonUtils";
import { hideToast } from "../../../store/CommonSlice";
import { useDispatch, useSelector } from 'react-redux';

const types = {
    error:'danger',
    success:'success',
    warning:'warning'
}

const toastStyles = {
    success: {
        backgroundColor: '#ffffff',
        color: '#6b7280'
    },
    danger: {
        backgroundColor: '#ffffff',
        color: '#6b7280'
    },
    warning: {
        backgroundColor: '#ffffff',
        color: '#6b7280'
    }
};

const toastIcons = {
    danger: 'fas fa-times-circle',
    warning: 'fas fa-exclamation-triangle',
    success: 'fas fa-check-circle'
};

const iconColors = {
    success: '#22c55e',
    danger: '#ef4444',
    warning: '#facc15'
};

const Toast = ()=>{
    const dispatch = useDispatch();
    const toasts = useSelector(state=>state.common.toasts);
    return(
        <div style={{position:'fixed',top:'1rem',left:'50%',transform:'translateX(-50%)',zIndex:'9999'}}>
            {toasts.map((toast) => {
                const toastType = types[toast.type] || 'success';
                const variantStyle = toastStyles[toastType] || toastStyles.success;
                const iconClass = toastIcons[toastType] || toastIcons.success;
                const iconColor = iconColors[toastType] || iconColors.success;
                const textColor = variantStyle.color;
                return (
                <div
                    key={toast.id}
                    className={`toast ${toastType}`}
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    style={{ opacity: 1, minWidth:'350px', ...variantStyle, border:'1px solid #e5e7eb', boxShadow:'0 8px 18px rgba(15, 23, 42, 0.12)' }}
                >
                <div
                    className="toast-header"
                    style={{ ...variantStyle, borderBottom:'1px solid #e5e7eb' }}
                >
                    <i data-feather="bell"></i>
                    <strong className="mr-auto" style={{ color: iconColor }}>{capitalizeFirstLetter(toast.type)} </strong>
                    <button
                        className="ml-2 mb-1 btn-close"
                        type="button"
                        onClick={() => dispatch(hideToast(toast.id))}
                        aria-label="Close"
                        style={{ filter: 'invert(0)' }}
                    ></button>
                </div>
                    {
                        isArray(toast.message) ?
                            toast.message.map((msg, index) => {
                                return (
                                    <div
                                        className="toast-body"
                                        key={index}
                                        style={{ color: textColor, display: 'flex', alignItems: 'center', gap: '8px' }}
                                    >
                                        <i className={iconClass} aria-hidden="true" style={{ width: '18px', height: '18px', fontSize: '18px', lineHeight: '18px', color: iconColor }}></i>
                                        <span>{msg}</span>
                                    </div>
                                )
                            })
                            :
                            <div className="toast-body" style={{ color: textColor, display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className={iconClass} aria-hidden="true" style={{ width: '18px', height: '18px', fontSize: '18px', lineHeight: '18px', color: iconColor }}></i>
                                <span>{toast.message}</span>
                                
                            </div>
                    }
                
            </div>
            )})}
    </div>
    )
}

export default Toast;